var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "upload-arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,0a50,50,0,1,0,50,50A50,50,0,0,0,50,0ZM45.43,68.78a3.65,3.65,0,1,1,3.65-3.65A3.65,3.65,0,0,1,45.43,68.78Zm0-30.26a3.65,3.65,0,1,1,3.65-3.65A3.65,3.65,0,0,1,45.43,38.52ZM53,61.22a3.65,3.65,0,1,1,3.65-3.65A3.65,3.65,0,0,1,53,61.22Zm0-15.13a3.65,3.65,0,1,1,3.65-3.65A3.65,3.65,0,0,1,53,46.09Zm7.57,7.57A3.65,3.65,0,1,1,64.22,50,3.65,3.65,0,0,1,60.57,53.65Z",
    fill: "#7e8890",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadArrow);
export default __webpack_public_path__ + "static/media/upload-arrow.81f658a46aaddc485e52b4802241be10.svg";
export { ForwardRef as ReactComponent };